import { render, staticRenderFns } from "./CategoriaWeb.vue?vue&type=template&id=52b0365e&lang=pug"
import script from "./CategoriaWeb.vue?vue&type=script&lang=js"
export * from "./CategoriaWeb.vue?vue&type=script&lang=js"
import style0 from "./CategoriaWeb.vue?vue&type=style&index=0&id=52b0365e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports